import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardDataFormMeta {
    cardStatus: FormInputMeta;
    cardProduct: FormInputMeta;
    cardType: FormInputMeta;
    effectiveDate: FormInputMeta;
    expirationDate: FormInputMeta;
    cardStatusDate: FormInputMeta;
    cardOppositionStatus: FormInputMeta;
    holderTitle: FormInputMeta;
    firstName: FormInputMeta;
    name2: FormInputMeta;
    name: FormInputMeta;
    cardName: FormInputMeta;
    gender: FormInputMeta;
    noLabel: FormInputMeta;
    pinCounter: FormInputMeta;
    pinGeneration: FormInputMeta;
    nbrPinTrial: FormInputMeta;
    primaryPan: FormInputMeta;
    primary_secondary: FormInputMeta;

    schema: any;
}

const cardDataFormMeta = {} as ICardDataFormMeta;

cardDataFormMeta.cardStatus = {
    name: "cardStatus",
    type: "text",
    label: "Statut Carte",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.cardProduct = {
    name: "cardProduct",
    type: "text",
    label: "Produit Carte",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.cardType = {
    name: "cardType",
    type: "text",
    label: "Type Carte",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.effectiveDate = {
    name: "effectiveDate",
    type: "date",
    label: "Date Effective",
    placeholder: "",
    validation: yup.date().notRequired(),
};

cardDataFormMeta.expirationDate = {
    name: "expirationDate",
    type: "date",
    label: "Date Expi.",
    placeholder: "",
    validation: yup.date().notRequired(),
};

cardDataFormMeta.cardStatusDate = {
    name: "cardStatusDate",
    type: "date",
    label: "Date Statut Carte",
    placeholder: "",
    validation: yup.date().notRequired(),
};

cardDataFormMeta.cardOppositionStatus = {
    name: "cardOppositionStatus",
    type: "checkbox",
    label: "Statut Opposition Carte",
    placeholder: "",
    validation: yup.boolean(),
};

cardDataFormMeta.holderTitle = {
    name: "holderTitle",
    type: "text",
    label: "Titre Porteur",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.firstName = {
    name: "firstName",
    type: "text",
    label: "Prénom",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.name2 = {
    name: "name2",
    type: "text",
    label: "Deuxième Nom",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.cardName = {
    name: "cardName",
    type: "text",
    label: "Nom Carte",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.gender = {
    name: "gender",
    type: "text",
    label: "Sexe",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.noLabel = {
    name: "noLabel",
    type: "text",
    label: "  ",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.pinCounter = {
    name: "pinCounter",
    type: "text",
    label: "Compteur PIN",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.pinGeneration = {
    name: "pinGeneration",
    type: "checkbox",
    label: "Génération Pin",
    placeholder: "",
    validation: yup.boolean(),
};

cardDataFormMeta.nbrPinTrial = {
    name: "nbrPinTrial",
    type: "number",
    label: "Nbr. d'Essai PIN",
    placeholder: "",
    validation: yup.number(),
};

cardDataFormMeta.primaryPan = {
    name: "primaryPan",
    type: "text",
    label: "PAN Primaire",
    placeholder: "",
    validation: yup.string(),
};

cardDataFormMeta.primary_secondary = {
    name: "primary_secondary",
    type: "radio",
    options: [{label: "Primaire", value: "primary"}, {label: "Secondaire", value: "secondary"}],
    label: "",
    placeholder: "",
    validation: yup.string(),
};


cardDataFormMeta.schema = yup.object().shape(getValidationSchema(cardDataFormMeta));

export default cardDataFormMeta;